import type { UserResponse } from "../types/user";

export const HOME_RECOGNITION_DASHBOARD_ACCESS_PERMISSIONS = [
  "home:recognition:dashboard",
] as const;
export const HOME_VIEW_ACCESS_PERMISSIONS = ["home:view"] as const;
export const USER_MANAGEMENT_ACCESS_PERMISSIONS = ["user:read"] as const;
export const USER_PASSWORD_UPDATE_ACCESS_PERMISSIONS = [
  "user:password:update",
] as const;
export const USER_API_CREDENTIALS_MANAGE_ACCESS_PERMISSIONS = [
  "user:api-credentials:manage",
] as const;
export const ROLE_MANAGEMENT_ACCESS_PERMISSIONS = [
  "role:read",
  "rbac:role:read",
] as const;
export const ROLE_PERMISSION_READ_ACCESS_PERMISSIONS = [
  "role:permission:read",
] as const;
export const PROJECT_MANAGEMENT_ACCESS_PERMISSIONS = [
  "project:read",
] as const;
export const PROJECT_READ_ACCESS_PERMISSIONS = [
  "project:read",
] as const;
export const PROJECT_CREATE_ACCESS_PERMISSIONS = [
  "project:create",
] as const;
export const PROJECT_UPDATE_ACCESS_PERMISSIONS = [
  "project:update",
] as const;
export const PROJECT_STATUS_UPDATE_ACCESS_PERMISSIONS = [
  "project:status:update",
] as const;
export const PROJECT_DELETE_ACCESS_PERMISSIONS = [
  "project:delete",
] as const;
export const PROJECT_VIEWER_SCOPE_READ_ACCESS_PERMISSIONS = [
  "project:viewer:read",
] as const;
export const PROJECT_VIEWER_BOARD_ACCESS_PERMISSIONS = [
  "project:viewer:board",
] as const;
export const PROJECT_VIEWER_ACCOUNT_UPDATE_ACCESS_PERMISSIONS = [
  "project:viewer:update",
] as const;
export const PROJECT_VIEWER_ACCOUNT_STATUS_UPDATE_ACCESS_PERMISSIONS = [
  "project:viewer:status:update",
] as const;
export const PROJECT_VIEWER_SCOPE_GRANT_ACCESS_PERMISSIONS = [
  "project:viewer:grant",
] as const;
export const PROJECT_VIEWER_MANAGEMENT_ACCESS_PERMISSIONS = [
  "project:viewer:board",
] as const;
export const PACKAGE_MANAGEMENT_ACCESS_PERMISSIONS = ["package:read"] as const;
export const PACKAGE_DEVICE_ACCESS_PERMISSIONS = ["package:device:read"] as const;
export const MODEL_MANAGEMENT_ACCESS_PERMISSIONS = ["model:read"] as const;
export const MODEL_UPLOAD_ACCESS_PERMISSIONS = ["model:upload"] as const;
export const MODEL_VALIDATE_ACCESS_PERMISSIONS = ["model:validate"] as const;
export const MODEL_EVALUATE_ACCESS_PERMISSIONS = ["model:evaluate"] as const;
export const MODEL_ACTIVATE_ACCESS_PERMISSIONS = ["model:activate"] as const;
export const MODEL_VALIDATION_READ_ACCESS_PERMISSIONS = [
  "model:read",
  "model:evaluate",
  "model:activate",
] as const;
export const MODEL_MAPPING_UPDATE_ACCESS_PERMISSIONS = [
  "model:mapping:update",
] as const;
export const MODEL_FUSION_UPDATE_ACCESS_PERMISSIONS = [
  "model:fusion:update",
] as const;
export const REGION_MANAGEMENT_ACCESS_PERMISSIONS = ["region:read"] as const;
export const PAYMENT_MERCHANT_MANAGEMENT_ACCESS_PERMISSIONS = [
  "payment:config:read",
] as const;
export const PAYMENT_MERCHANT_CREATE_ACCESS_PERMISSIONS = [
  "payment:config:create",
] as const;
export const PAYMENT_MERCHANT_UPDATE_ACCESS_PERMISSIONS = [
  "payment:config:update",
] as const;
export const PAYMENT_MERCHANT_VALIDATE_ACCESS_PERMISSIONS = [
  "payment:config:validate",
] as const;
export const PAYMENT_MERCHANT_STATUS_UPDATE_ACCESS_PERMISSIONS = [
  "payment:config:status:update",
] as const;
export const PAYMENT_MERCHANT_SET_DEFAULT_ACCESS_PERMISSIONS = [
  "payment:config:set_default",
] as const;
export const PAYMENT_MERCHANT_DELETE_ACCESS_PERMISSIONS = [
  "payment:config:delete",
] as const;
export const SYSTEM_CONFIG_ACCESS_PERMISSIONS = ["system:config:read"] as const;
export const SYSTEM_CONFIG_UPDATE_ACCESS_PERMISSIONS = [
  "system:config:update",
] as const;
export const OPERATIONS_MENDER_READ_ACCESS_PERMISSIONS = [
  "operations:mender:read",
] as const;
export const OPERATIONS_MENDER_UPDATE_ACCESS_PERMISSIONS = [
  "operations:mender:update",
] as const;
export const MENDER_OTA_CONFIG_READ_ACCESS_PERMISSIONS = [
  ...SYSTEM_CONFIG_ACCESS_PERMISSIONS,
  ...OPERATIONS_MENDER_READ_ACCESS_PERMISSIONS,
] as const;
export const MENDER_OTA_CONFIG_UPDATE_ACCESS_PERMISSIONS = [
  ...SYSTEM_CONFIG_UPDATE_ACCESS_PERMISSIONS,
  ...OPERATIONS_MENDER_UPDATE_ACCESS_PERMISSIONS,
] as const;
export const SYSTEM_SETTINGS_ACCESS_PERMISSIONS = [
  ...SYSTEM_CONFIG_ACCESS_PERMISSIONS,
  ...OPERATIONS_MENDER_READ_ACCESS_PERMISSIONS,
] as const;
export const OPERATIONS_DEVICE_UPGRADE_READ_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:read",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_BINDING_READ_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:binding:read",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_BINDING_DETAIL_READ_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:binding:detail:read",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_ARTIFACT_READ_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:artifact:read",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_BATCH_READ_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:batch:read",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_BATCH_DETAIL_READ_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:batch:detail:read",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_ACCESS_PERMISSIONS = [
  ...OPERATIONS_DEVICE_UPGRADE_BINDING_READ_ACCESS_PERMISSIONS,
  ...OPERATIONS_DEVICE_UPGRADE_ARTIFACT_READ_ACCESS_PERMISSIONS,
  ...OPERATIONS_DEVICE_UPGRADE_BATCH_READ_ACCESS_PERMISSIONS,
] as const;
export const OPERATIONS_DEVICE_UPGRADE_DEVICE_SYNC_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:device:sync",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_ARTIFACT_CREATE_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:artifact:create",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_ARTIFACT_UPDATE_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:artifact:update",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_ARTIFACT_ENABLE_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:artifact:enable",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_ARTIFACT_DISABLE_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:artifact:disable",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_ARTIFACT_DELETE_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:artifact:delete",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_BATCH_CREATE_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:batch:create",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_BATCH_SYNC_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:batch:sync",
] as const;
export const OPERATIONS_DEVICE_UPGRADE_BATCH_CANCEL_ACCESS_PERMISSIONS = [
  "operations:device_upgrade:batch:cancel",
] as const;
export const IMAGE_DETECTION_ACCESS_PERMISSIONS = [
  "detection:create",
  "detection:analyze",
] as const;
export const STATISTICS_SPECIES_ANALYSIS_ACCESS_PERMISSIONS = [
  "statistics:species:read",
] as const;
export const STATISTICS_TREND_ANALYSIS_ACCESS_PERMISSIONS = [
  "statistics:trend:read",
] as const;
export const STATISTICS_TREND_EXPORT_ACCESS_PERMISSIONS = [
  "statistics:trend:export",
] as const;
export const STATISTICS_EXPORT_ACCESS_PERMISSIONS = [
  ...STATISTICS_TREND_EXPORT_ACCESS_PERMISSIONS,
] as const;
export const STATISTICS_ACCESS_PERMISSIONS = [
  ...STATISTICS_SPECIES_ANALYSIS_ACCESS_PERMISSIONS,
  ...STATISTICS_TREND_ANALYSIS_ACCESS_PERMISSIONS,
] as const;
export const HISTORY_ACCESS_PERMISSIONS = ["history:read"] as const;
export const HISTORY_DETAIL_ACCESS_PERMISSIONS = [
  "history:detail:read",
] as const;
export const PAYMENT_ACCESS_PERMISSIONS = ["payment:read"] as const;
export const PAYMENT_DETAIL_ACCESS_PERMISSIONS = [
  "payment:detail:read",
] as const;
export const PAYMENT_QUERY_RESULT_ACCESS_PERMISSIONS = [
  "payment:query_result",
] as const;
export const OPERATION_LOG_ACCESS_PERMISSIONS = ["system:logs"] as const;
export const ANNOTATION_MANAGEMENT_ACCESS_PERMISSIONS = [
  "history:read",
  "history:update",
] as const;
export const REVIEW_EXPORT_ACCESS_PERMISSIONS = [
  "history:read",
  "history:export",
] as const;
export const MANUAL_RECOGNITION_ACCESS_PERMISSIONS = [
  "manual_recognition:read",
] as const;
export const MANUAL_RECOGNITION_SUBMIT_PERMISSIONS = [
  "manual_recognition:submit",
] as const;
export const DEVICE_ACCESS_PERMISSIONS = ["device:read"] as const;
export const DEVICE_DETAIL_ACCESS_PERMISSIONS = [
  "device:detail:read",
] as const;
export const DEVICE_DISTRIBUTION_ACCESS_PERMISSIONS = [
  "device:distribution:read",
] as const;
export const DEVICE_UPDATE_ACCESS_PERMISSIONS = ["device:update"] as const;
export const DEVICE_LOCATION_UPDATE_ACCESS_PERMISSIONS = [
  "device:location:update",
] as const;
export const DEVICE_DELETE_ACCESS_PERMISSIONS = ["device:delete"] as const;
export const DEVICE_EXPORT_ACCESS_PERMISSIONS = ["device:export"] as const;

export interface PermissionTreePageDefinition {
  key: string;
  titleKey: string;
  descriptionKey?: string;
  capabilities: readonly PermissionTreeCapabilityDefinition[];
}

export interface PermissionTreeCapabilityDefinition {
  key: string;
  labelKey: string;
  defaultLabel: string;
  permissionNames: readonly string[];
}

export interface PermissionTreeSectionDefinition {
  key: string;
  titleKey: string;
  pages: readonly PermissionTreePageDefinition[];
}

export const ROLE_PERMISSION_TREE_SECTIONS: readonly PermissionTreeSectionDefinition[] =
  [
    {
      key: "home",
      titleKey: "menu.home",
      pages: [
          {
            key: "homeDashboard",
            titleKey: "menu.home",
            capabilities: [
              {
                key: "home.view",
                labelKey: "role.permissions.names.home_view",
                defaultLabel: "View",
                permissionNames: HOME_VIEW_ACCESS_PERMISSIONS,
              },
              {
                key: "home.recognitionDashboard.view",
                labelKey: "role.permissions.names.home_recognition_dashboard",
                defaultLabel: "Home dashboard",
                permissionNames: HOME_RECOGNITION_DASHBOARD_ACCESS_PERMISSIONS,
              },
            ],
          },
        ],
      },
    {
      key: "dataCenter",
      titleKey: "menu.dataCenter",
      pages: [
        {
          key: "speciesAnalysis",
          titleKey: "menu.speciesAnalysis",
          capabilities: [
            {
              key: "speciesAnalysis.view",
              labelKey: "role.permissions.names.statistics_species_read",
              defaultLabel: "View",
              permissionNames: STATISTICS_SPECIES_ANALYSIS_ACCESS_PERMISSIONS,
            },
          ],
        },
        {
          key: "trendAnalysis",
          titleKey: "menu.trendAnalysis",
          capabilities: [
            {
              key: "trendAnalysis.view",
              labelKey: "role.permissions.names.statistics_trend_read",
              defaultLabel: "View",
              permissionNames: STATISTICS_TREND_ANALYSIS_ACCESS_PERMISSIONS,
            },
            {
              key: "trendAnalysis.export",
              labelKey: "role.permissions.names.statistics_trend_export",
              defaultLabel: "Export",
              permissionNames: STATISTICS_TREND_EXPORT_ACCESS_PERMISSIONS,
            },
          ],
        },
        {
          key: "deviceDistribution",
          titleKey: "menu.deviceMosquito",
          capabilities: [
            {
              key: "deviceDistribution.view",
              labelKey: "role.permissions.names.device_distribution_read",
              defaultLabel: "View",
              permissionNames: DEVICE_DISTRIBUTION_ACCESS_PERMISSIONS,
            },
          ],
        },
        {
          key: "history",
          titleKey: "menu.history",
          capabilities: [
            {
              key: "history.view",
              labelKey: "role.permissions.names.history_read",
              defaultLabel: "View",
              permissionNames: ["history:read"],
            },
            {
              key: "history.viewDetails",
              labelKey: "role.permissions.names.history_detail_read",
              defaultLabel: "View Details",
              permissionNames: HISTORY_DETAIL_ACCESS_PERMISSIONS,
            },
            {
              key: "history.delete",
              labelKey: "role.permissions.names.history_delete",
              defaultLabel: "Delete",
              permissionNames: ["history:delete"],
            },
          ],
        },
      ],
    },
    {
      key: "manualRecognition",
      titleKey: "menu.manualRecognition",
      pages: [
        {
          key: "manualRecognition",
          titleKey: "menu.manualRecognition",
          capabilities: [
            {
              key: "manualRecognition.view",
              labelKey: "role.permissions.names.manual_recognition_read",
              defaultLabel: "View",
              permissionNames: MANUAL_RECOGNITION_ACCESS_PERMISSIONS,
            },
            {
              key: "manualRecognition.submit",
              labelKey: "role.permissions.names.manual_recognition_submit",
              defaultLabel: "Submit",
              permissionNames: MANUAL_RECOGNITION_SUBMIT_PERMISSIONS,
            },
          ],
        },
      ],
    },
    {
      key: "deviceManagement",
      titleKey: "menu.deviceManagement",
      pages: [
        {
          key: "deviceManagement",
          titleKey: "menu.deviceManagement",
          capabilities: [
            {
              key: "deviceManagement.view",
              labelKey: "device:management.actions.view",
              defaultLabel: "View",
              permissionNames: ["device:read"],
            },
            {
              key: "deviceManagement.viewDetails",
              labelKey: "role.permissions.names.device_detail_read",
              defaultLabel: "View Details",
              permissionNames: DEVICE_DETAIL_ACCESS_PERMISSIONS,
            },
            {
              key: "deviceManagement.edit",
              labelKey: "device:management.actions.edit",
              defaultLabel: "Edit",
              permissionNames: ["device:update"],
            },
            {
              key: "deviceManagement.location",
              labelKey: "device:management.actions.location",
              defaultLabel: "Location",
              permissionNames: DEVICE_LOCATION_UPDATE_ACCESS_PERMISSIONS,
            },
            {
              key: "deviceManagement.delete",
              labelKey: "device:management.actions.delete",
              defaultLabel: "Delete",
              permissionNames: ["device:delete"],
            },
            {
              key: "deviceManagement.export",
              labelKey: "role.permissions.names.device_export",
              defaultLabel: "Export",
              permissionNames: DEVICE_EXPORT_ACCESS_PERMISSIONS,
            },
          ],
        },
      ],
    },
    {
      key: "operationsCenter",
      titleKey: "menu.operationsCenter",
      pages: [
        {
          key: "deviceUpgradeBindings",
          titleKey: "menu.deviceUpgradeBindings",
          capabilities: [
            {
              key: "deviceUpgradeBindings.view",
              labelKey: "role.permissions.names.operations_device_upgrade_binding_read",
              defaultLabel: "View",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_BINDING_READ_ACCESS_PERMISSIONS,
            },
            {
              key: "deviceUpgradeBindings.details",
              labelKey: "role.permissions.names.operations_device_upgrade_binding_detail_read",
              defaultLabel: "Details",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_BINDING_DETAIL_READ_ACCESS_PERMISSIONS,
            },
            {
              key: "deviceUpgradeBindings.sync",
              labelKey: "role.permissions.names.operations_device_upgrade_device_sync",
              defaultLabel: "Sync OTA devices",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_DEVICE_SYNC_ACCESS_PERMISSIONS,
            },
          ],
        },
        {
          key: "deviceUpgradeArtifacts",
          titleKey: "menu.deviceUpgradeArtifacts",
          capabilities: [
            {
              key: "deviceUpgradeArtifacts.view",
              labelKey: "role.permissions.names.operations_device_upgrade_artifact_read",
              defaultLabel: "View",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_ARTIFACT_READ_ACCESS_PERMISSIONS,
            },
            {
              key: "deviceUpgradeArtifacts.create",
              labelKey: "role.permissions.names.operations_device_upgrade_artifact_create",
              defaultLabel: "Add",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_ARTIFACT_CREATE_ACCESS_PERMISSIONS,
            },
            {
              key: "deviceUpgradeArtifacts.update",
              labelKey: "role.permissions.names.operations_device_upgrade_artifact_update",
              defaultLabel: "Edit",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_ARTIFACT_UPDATE_ACCESS_PERMISSIONS,
            },
            {
              key: "deviceUpgradeArtifacts.enable",
              labelKey: "role.permissions.names.operations_device_upgrade_artifact_enable",
              defaultLabel: "Restore",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_ARTIFACT_ENABLE_ACCESS_PERMISSIONS,
            },
            {
              key: "deviceUpgradeArtifacts.disable",
              labelKey: "role.permissions.names.operations_device_upgrade_artifact_disable",
              defaultLabel: "Disable",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_ARTIFACT_DISABLE_ACCESS_PERMISSIONS,
            },
            {
              key: "deviceUpgradeArtifacts.delete",
              labelKey: "role.permissions.names.operations_device_upgrade_artifact_delete",
              defaultLabel: "Delete",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_ARTIFACT_DELETE_ACCESS_PERMISSIONS,
            },
          ],
        },
        {
          key: "deviceUpgradeBatches",
          titleKey: "menu.deviceUpgradeBatches",
          capabilities: [
            {
              key: "deviceUpgradeBatches.view",
              labelKey: "role.permissions.names.operations_device_upgrade_batch_read",
              defaultLabel: "View",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_BATCH_READ_ACCESS_PERMISSIONS,
            },
            {
              key: "deviceUpgradeBatches.details",
              labelKey: "role.permissions.names.operations_device_upgrade_batch_detail_read",
              defaultLabel: "Details",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_BATCH_DETAIL_READ_ACCESS_PERMISSIONS,
            },
            {
              key: "deviceUpgradeBatches.create",
              labelKey: "role.permissions.names.operations_device_upgrade_batch_create",
              defaultLabel: "Add",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_BATCH_CREATE_ACCESS_PERMISSIONS,
            },
            {
              key: "deviceUpgradeBatches.sync",
              labelKey: "role.permissions.names.operations_device_upgrade_batch_sync",
              defaultLabel: "Sync",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_BATCH_SYNC_ACCESS_PERMISSIONS,
            },
            {
              key: "deviceUpgradeBatches.cancel",
              labelKey: "role.permissions.names.operations_device_upgrade_batch_cancel",
              defaultLabel: "Cancel",
              permissionNames: OPERATIONS_DEVICE_UPGRADE_BATCH_CANCEL_ACCESS_PERMISSIONS,
            },
          ],
        },
      ],
    },
    {
      key: "systemManagement",
      titleKey: "menu.systemManagement",
      pages: [
        {
          key: "userManagement",
          titleKey: "menu.userManagement",
          capabilities: [
            {
              key: "userManagement.view",
              labelKey: "role.permissions.names.user_read",
              defaultLabel: "View",
              permissionNames: ["user:read"],
            },
            {
              key: "userManagement.create",
              labelKey: "user.actions.create",
              defaultLabel: "Create user",
              permissionNames: ["user:create"],
            },
            {
              key: "userManagement.edit",
              labelKey: "user.actions.edit",
              defaultLabel: "Edit",
              permissionNames: ["user:update"],
            },
            {
              key: "userManagement.changePassword",
              labelKey: "user.actions.changePassword",
              defaultLabel: "Change password",
              permissionNames: USER_PASSWORD_UPDATE_ACCESS_PERMISSIONS,
            },
            {
              key: "userManagement.manageApiCredentials",
              labelKey: "user.actions.manageApiCredentials",
              defaultLabel: "API credentials",
              permissionNames: USER_API_CREDENTIALS_MANAGE_ACCESS_PERMISSIONS,
            },
            {
              key: "userManagement.delete",
              labelKey: "user.actions.delete",
              defaultLabel: "Delete",
              permissionNames: ["user:delete"],
            },
          ],
        },
        {
          key: "roleManagement",
          titleKey: "menu.roleManagement",
          capabilities: [
            {
              key: "roleManagement.view",
              labelKey: "role.permissions.names.role_management_view",
              defaultLabel: "View",
              permissionNames: ["role:read", "rbac:role:read"],
            },
            {
              key: "roleManagement.create",
              labelKey: "role.actions.create",
              defaultLabel: "Create role",
              permissionNames: ["role:create", "rbac:role:create"],
            },
            {
              key: "roleManagement.viewPermissions",
              labelKey: "role.actions.viewPermissions",
              defaultLabel: "View permissions",
              permissionNames: ROLE_PERMISSION_READ_ACCESS_PERMISSIONS,
            },
            {
              key: "roleManagement.edit",
              labelKey: "role.actions.edit",
              defaultLabel: "Edit",
              permissionNames: ["role:update", "rbac:role:update"],
            },
            {
              key: "roleManagement.delete",
              labelKey: "role.actions.delete",
              defaultLabel: "Delete",
              permissionNames: ["role:delete", "rbac:role:delete"],
            },
          ],
        },
        {
          key: "regionManagement",
          titleKey: "menu.regionManagement",
          capabilities: [
            {
              key: "regionManagement.view",
              labelKey: "role.permissions.names.region_read",
              defaultLabel: "View",
              permissionNames: ["region:read"],
            },
            {
              key: "regionManagement.createCustom",
              labelKey: "region.actions.createCustom",
              defaultLabel: "Create custom region",
              permissionNames: ["region:create"],
            },
            {
              key: "regionManagement.edit",
              labelKey: "region.actions.edit",
              defaultLabel: "Edit",
              permissionNames: ["region:update"],
            },
            {
              key: "regionManagement.delete",
              labelKey: "region.actions.delete",
              defaultLabel: "Delete",
              permissionNames: ["region:delete"],
            },
          ],
        },
        {
          key: "systemSettings",
          titleKey: "menu.systemSettings",
          capabilities: [
            {
              key: "systemSettings.view",
              labelKey: "role.permissions.names.system_config_read",
              defaultLabel: "View",
              permissionNames: ["system:config", "system:config:read"],
            },
            {
              key: "systemSettings.save",
              labelKey: "role.permissions.names.system_config_update",
              defaultLabel: "Save",
              permissionNames: ["system:config:update"],
            },
          ],
        },
        {
          key: "operationLog",
          titleKey: "menu.operationLog",
          capabilities: [
            {
              key: "operationLog.view",
              labelKey: "role.permissions.names.system_logs",
              defaultLabel: "View",
              permissionNames: ["system:log", "system:logs"],
            },
          ],
        },
      ],
    },
    {
      key: "projectManagement",
      titleKey: "menu.projectManagementGroup",
      pages: [
        {
          key: "projectManagement",
          titleKey: "menu.projectManagementV1",
          capabilities: [
            {
              key: "projectManagement.view",
              labelKey: "role.permissions.names.project_manage",
              defaultLabel: "View",
              permissionNames: ["project:read"],
            },
            {
              key: "projectManagement.create",
              labelKey: "project.actions.create",
              defaultLabel: "Create project",
              permissionNames: ["project:create"],
            },
            {
              key: "projectManagement.edit",
              labelKey: "project.actions.edit",
              defaultLabel: "Edit",
              permissionNames: ["project:update"],
            },
            {
              key: "projectManagement.enableDisable",
              labelKey: "project.actions.enableDisable",
              defaultLabel: "Enable/Disable",
              permissionNames: ["project:status:update"],
            },
            {
              key: "projectManagement.delete",
              labelKey: "project.actions.delete",
              defaultLabel: "Delete",
              permissionNames: ["project:delete"],
            },
            {
              key: "projectManagement.viewScopes",
              labelKey: "project.actions.viewScopes",
              defaultLabel: "View authorizations",
              permissionNames: ["project:viewer:read"],
            },
          ],
        },
        {
          key: "projectViewerScopes",
          titleKey: "menu.viewerAccountBoard",
          capabilities: [
            {
              key: "projectViewerScopes.view",
              labelKey: "role.permissions.names.enter_project_viewer_board",
              defaultLabel: "Authorized account dashboard",
              permissionNames: PROJECT_VIEWER_BOARD_ACCESS_PERMISSIONS,
            },
            {
              key: "projectViewerScopes.editAccount",
              labelKey: "projectV1.actions.editAccount",
              defaultLabel: "Edit",
              permissionNames: ["project:viewer:update"],
            },
            {
              key: "projectViewerScopes.enableDisableAccount",
              labelKey: "projectV1.actions.enableDisableAccount",
              defaultLabel: "Enable/Disable",
              permissionNames: ["project:viewer:status:update"],
            },
            {
              key: "projectViewerScopes.manageAuthorization",
              labelKey: "projectV1.actions.manageAuthorization",
              defaultLabel: "Manage projects",
              permissionNames: ["project:viewer:grant"],
            },
          ],
        },
        {
          key: "packageManagement",
          titleKey: "menu.packageManagementV1",
          capabilities: [
            {
              key: "packageManagement.view",
              labelKey: "role.permissions.names.package_manage",
              defaultLabel: "View",
              permissionNames: PACKAGE_MANAGEMENT_ACCESS_PERMISSIONS,
            },
            {
              key: "packageManagement.viewDevices",
              labelKey: "role.permissions.names.package_view_devices",
              defaultLabel: "View devices",
              permissionNames: PACKAGE_DEVICE_ACCESS_PERMISSIONS,
            },
          ],
        },
      ],
    },
    {
      key: "modelManagement",
      titleKey: "menu.modelManagement",
      pages: [
        {
          key: "modelManagement",
          titleKey: "menu.modelManagement",
          capabilities: [
            {
              key: "modelManagement.view",
              labelKey: "role.permissions.names.model_read",
              defaultLabel: "View",
              permissionNames: MODEL_MANAGEMENT_ACCESS_PERMISSIONS,
            },
            {
              key: "modelManagement.upload",
              labelKey: "role.permissions.names.model_upload",
              defaultLabel: "Upload models",
              permissionNames: MODEL_UPLOAD_ACCESS_PERMISSIONS,
            },
            {
              key: "modelManagement.validate",
              labelKey: "role.permissions.names.model_validate",
              defaultLabel: "Validate models",
              permissionNames: MODEL_VALIDATE_ACCESS_PERMISSIONS,
            },
            {
              key: "modelManagement.activate",
              labelKey: "role.permissions.names.model_activate",
              defaultLabel: "Activate or deactivate models",
              permissionNames: MODEL_ACTIVATE_ACCESS_PERMISSIONS,
            },
            {
              key: "modelManagement.mapping",
              labelKey: "role.permissions.names.model_mapping_update",
              defaultLabel: "Update type mappings",
              permissionNames: MODEL_MAPPING_UPDATE_ACCESS_PERMISSIONS,
            },
            {
              key: "modelManagement.fusion",
              labelKey: "role.permissions.names.model_fusion_update",
              defaultLabel: "Update fusion strategy",
              permissionNames: MODEL_FUSION_UPDATE_ACCESS_PERMISSIONS,
            },
          ],
        },
      ],
    },
    {
      key: "paymentCenter",
      titleKey: "menu.paymentCenter",
      pages: [
        {
          key: "orderManagement",
          titleKey: "menu.orderManagement",
          capabilities: [
            {
              key: "orderManagement.view",
              labelKey: "role.permissions.names.payment_read",
              defaultLabel: "View",
              permissionNames: PAYMENT_ACCESS_PERMISSIONS,
            },
            {
              key: "orderManagement.viewDetails",
              labelKey: "role.permissions.names.payment_detail_read",
              defaultLabel: "View Details",
              permissionNames: PAYMENT_DETAIL_ACCESS_PERMISSIONS,
            },
            {
              key: "orderManagement.queryResult",
              labelKey: "role.permissions.names.payment_query_result",
              defaultLabel: "View payment result",
              permissionNames: PAYMENT_QUERY_RESULT_ACCESS_PERMISSIONS,
            },
          ],
        },
        {
          key: "paymentMerchantManagement",
          titleKey: "menu.paymentMerchantManagement",
          capabilities: [
            {
              key: "paymentMerchantManagement.view",
              labelKey: "role.permissions.names.payment_config_read",
              defaultLabel: "View",
              permissionNames: PAYMENT_MERCHANT_MANAGEMENT_ACCESS_PERMISSIONS,
            },
            {
              key: "paymentMerchantManagement.create",
              labelKey: "paymentMerchant.actions.create",
              defaultLabel: "Create merchant",
              permissionNames: PAYMENT_MERCHANT_CREATE_ACCESS_PERMISSIONS,
            },
            {
              key: "paymentMerchantManagement.edit",
              labelKey: "paymentMerchant.actions.edit",
              defaultLabel: "Edit",
              permissionNames: PAYMENT_MERCHANT_UPDATE_ACCESS_PERMISSIONS,
            },
            {
              key: "paymentMerchantManagement.validate",
              labelKey: "paymentMerchant.actions.validate",
              defaultLabel: "Validate",
              permissionNames: PAYMENT_MERCHANT_VALIDATE_ACCESS_PERMISSIONS,
            },
            {
              key: "paymentMerchantManagement.activateDeactivate",
              labelKey: "paymentMerchant.actions.activateDeactivate",
              defaultLabel: "Activate/Deactivate",
              permissionNames: PAYMENT_MERCHANT_STATUS_UPDATE_ACCESS_PERMISSIONS,
            },
            {
              key: "paymentMerchantManagement.setDefault",
              labelKey: "paymentMerchant.actions.setFallbackDefault",
              defaultLabel: "Set default",
              permissionNames: PAYMENT_MERCHANT_SET_DEFAULT_ACCESS_PERMISSIONS,
            },
            {
              key: "paymentMerchantManagement.delete",
              labelKey: "paymentMerchant.actions.delete",
              defaultLabel: "Delete",
              permissionNames: PAYMENT_MERCHANT_DELETE_ACCESS_PERMISSIONS,
            },
          ],
        },
      ],
    },
  ];

const PERMISSION_GROUPS = [
  ["role:read", "rbac:role:read"],
  ["role:create", "rbac:role:create"],
  ["role:update", "rbac:role:update"],
  ["role:delete", "rbac:role:delete"],
  ["role:assign", "rbac:role:assign", "rbac:user:roles"],
  ["system:config", "system:config:read"],
  ["system:log", "system:logs"],
  ["home:dashboard", "home:recognition:dashboard"],
  [
    "stat:read",
    "statistics:species:read",
    "statistics:trend:read",
  ],
  ["device:distribution", "device:distribution:read"],
] as const;

const PERMISSION_ALIASES = new Map<string, readonly string[]>(
  PERMISSION_GROUPS.flatMap((group) =>
    group.map((permission) => [permission, group]),
  ),
);

PERMISSION_ALIASES.set("statistics:trend:export", [
  "statistics:trend:export",
  "statistics:export",
  "stat:export",
]);
PERMISSION_ALIASES.set("statistics:export", ["statistics:export", "stat:export"]);
PERMISSION_ALIASES.set("stat:export", ["stat:export", "statistics:export"]);

const expandPermissionAliases = (permission: string): readonly string[] =>
  PERMISSION_ALIASES.get(permission) || [permission];

export const hasPermission = (
  user: UserResponse | null | undefined,
  permission: string,
): boolean => {
  if (!user) {
    return false;
  }

  if (user.is_superuser) {
    return true;
  }

  const userPermissions = new Set(user.permissions || []);
  return expandPermissionAliases(permission).some((candidate) =>
    userPermissions.has(candidate),
  );
};

export const hasAnyPermissions = (
  user: UserResponse | null | undefined,
  permissions: readonly string[],
): boolean => permissions.some((permission) => hasPermission(user, permission));

export const hasAllPermissions = (
  user: UserResponse | null | undefined,
  permissions: readonly string[],
): boolean =>
  permissions.every((permission) => hasPermission(user, permission));
